import FleetReporting from '@/pages/Fleet/Dashboard/FleetReporting';
import { Monitor, Monitors } from '@/pages/AttendTrack/pages';
import { Dashboard } from '@/pages/CustomerService/pages';

const attendTrackRoutes = [
  { path: 'monitors', element: <Monitors /> },
  { path: 'monitor', element: <Monitor /> },
];

const atcRoutes = [
  {
    path: 'atc',
    children: [{ path: 'dashboard', element: <Dashboard /> }],
  },
];
const fleetRoutes = [
  {
    path: 'fleet',
    children: [{ path: 'dashboard', element: <FleetReporting /> }],
  },
];

export const publicRoutes = [...attendTrackRoutes, ...atcRoutes, ...fleetRoutes];
